const map = {
	"./andrew_drawing.jpg": 4565,
	"./apple_shading.png": 8974,
	"./birdhouse.jpg": 5922,
	"./bumblebee.jpg": 6144,
	"./dani_drawing.jpg": 9504,
	"./deltoid_shoulder.jpg": 1331,
	"./dollar_memory.png": 2717,
	"./drawing_hands.jpg": 3652,
	"./egg_drawing.png": 4497,
	"./elephant_nikon.png": 7238,
	"./english_teacher_drawing.jpg": 985,
	"./flower_charcoal.png": 1720,
	"./flyers_on_the_wall.png": 9227,
	"./fox.jpg": 498,
	"./japan_receipts.jpg": 5965,
	"./jes_drawing.jpg": 9784,
	"./leah_on_couch.jpg": 7208,
	"./mushroom_birdhouse.jpg": 9845,
	"./nueva_rosenberg.jpg": 9172,
	"./nueva_skybridge.jpg": 8591,
	"./octopus.jpg": 3982,
	"./painted_jewelry_box.jpg": 1523,
	"./photography_biz_cards.jpg": 8178,
	"./raku_fired_box.jpg": 609,
	"./roya_drawing.jpg": 1901,
	"./shocked_pineapple.jpg": 4251,
	"./skeleton_2024head.jpg": 3415,
	"./skeleton_hand.jpg": 1846,
	"./skeleton_handonshoulder.jpg": 5749,
	"./skeleton_torso.jpg": 4032,
	"./stained_glass_plate.jpg": 461,
	"./sushi_drawing.jpg": 7972,
	"./triangle_clay_plate.jpg": 452,
	"./upside_down_chair.png": 3062,
	"./warhol_daisies.jpg": 6825
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8323;